"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function ArModeButton(props) {
    const { children, iconName, selected, onClick, className, iconWidth, iconHeight, } = props;
    return ((0, jsx_runtime_1.jsxs)(Button, { className: className, onClick: onClick, selected: selected, "data-e2e": 'ArModeButton_Button', children: [(0, jsx_runtime_1.jsx)(ui_1.Icon, { name: iconName, width: iconWidth || 24, height: iconHeight || 24, selected: selected, "data-e2e": 'ArModeButton_Icon' }), children] }));
}
exports.default = ArModeButton;
const Button = (0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 60px;
  height: 60px;
  margin: 10px;
  padding: 0;

  background-color: ${props => props.selected ? props.theme.accentGreen : props.theme.black_50};
  border-radius: 50%;

  cursor: pointer;

  pointer-events: auto;
  fill: white;
`;
